import { render, staticRenderFns } from "./InsurancesPlanDetailsTable.vue?vue&type=template&id=7e1e4b61&"
import script from "./InsurancesPlanDetailsTable.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports